export default __webpack_public_path__ + "static/media/currychickpeas@3x.51cc72af.jpg";